import { useContext, useEffect } from "react";
import { PageContext } from "../App";

export default function Market()
{
    const {currentComponentName, setCurrentComponentName} = useContext(PageContext);
    useEffect(() => {
      setCurrentComponentName("Market");
    }, [])

    return <></>

}